import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AboutSection from '../components/AboutSection';

export default function NosotrosPage() {
  return (
    <>
      <Header />
      <main className="bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-2">
          <h1 className="text-4xl sm:text-5xl font-light text-neutral-900 tracking-tight" style={{ fontFamily: 'Cormorant Garamond, Georgia, serif' }} data-testid="nosotros-h1">
            Carolina Riestra y el estudio CR Home
          </h1>
        </div>
        <AboutSection />
      </main>
      <Footer />
    </>
  );
}
